export default "__VITE_ASSET__wkuj_$2___"